import camelCase from "lodash/camelCase";
import snakeCase from "lodash/snakeCase";
import isPlainObject from "lodash/isPlainObject";
import transform from "lodash/transform";
function _deepMapKeys(obj, transformKey) {
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return _deepMapKeys(item, transformKey); });
    }
    if (isPlainObject(obj)) {
        return transform(obj, function (acc, value, key) {
            acc[transformKey(key)] = _deepMapKeys(value, transformKey);
        });
    }
    return obj;
}
export var deepCamelCaseKeys = function (obj) { return _deepMapKeys(obj, camelCase); };
export var deepSnakeCaseKeys = function (obj) { return _deepMapKeys(obj, snakeCase); };
export default { deepCamelCaseKeys: deepCamelCaseKeys, deepSnakeCaseKeys: deepSnakeCaseKeys };
